module.exports = __webpack_public_path__ + "img/男生头像.a9df617a.png";